import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';

// components
import { SbSharedSearchSuggestions } from '../SbSharedSearchSuggestions/SbSharedSearchSuggestions';
import { SbSharedTitle } from '../SbSharedTitle/SbSharedTitle';
import {
    FILTER_SEARCH,
    FILTER_REFINE_SEARCH,
} from '../SbSharedRefineMenu/sbSharedRefineMenuConstants';
import { SbSharedNullSearchResultsHeader } from '../SbSharedNullSearchResultsHeader/SbSharedNullSearchResultsHeader';

// styles
import styles from './SbRespNullSearchResultsHeader.scss';

const shouldShowSearchHeader = appliedFilters => {
    return appliedFilters.some(
        ({ name }) => name === FILTER_SEARCH || name === FILTER_REFINE_SEARCH
    );
};

export const SbRespNullSearchResultsHeaderComponent = ({ searchTerm, itemSearch }) => {
    const { appliedFilters = [], relatedSearchResults } = itemSearch;
    const { edges: items = [] } = relatedSearchResults;
    const shouldShowSuggestions = !items.length;

    return shouldShowSearchHeader(appliedFilters) ? (
        <div className={styles.container}>
            <SbSharedNullSearchResultsHeader itemSearch={itemSearch} />
            {shouldShowSuggestions && (
                <SbSharedSearchSuggestions
                    searchTerm={searchTerm}
                    itemSearch={itemSearch}
                    className={styles.searchSuggestions}
                />
            )}
        </div>
    ) : (
        <SbSharedTitle itemSearch={itemSearch} searchTerm={searchTerm} />
    );
};

SbRespNullSearchResultsHeaderComponent.propTypes = {
    searchTerm: PropTypes.string,
    itemSearch: PropTypes.object.isRequired,
};

export const SbRespNullSearchResultsHeader = createFragmentContainer(
    SbRespNullSearchResultsHeaderComponent,
    {
        itemSearch: graphql`
            fragment SbRespNullSearchResultsHeader_itemSearch on ItemSearchQueryConnection {
                ...SbSharedSearchSuggestions_itemSearch
                ...SbSharedTitle_itemSearch
                ...SbSharedNullSearchResultsHeader_itemSearch
                relatedSearchResults {
                    edges {
                        node {
                            item {
                                serviceId
                            }
                        }
                    }
                }
                appliedFilters {
                    name
                }
            }
        `,
    }
);
